import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function isStrongPassword(password: string): [boolean, string] {
	if (password.length < 8) {
		return [false, "A senha deve ter no mínimo 8 caracteres"];
	}

	if (!/[a-zA-Z]/.test(password)) {
		return [false, "A senha deve ter no mínimo uma letra"];
	}

	if (!/[0-9]/.test(password)) {
		return [false, "A senha deve ter no mínimo um número"];
	}

	return [true, ""];
}
